import '../css/module_accessory.scss';

import Collapse from 'bootstrap/js/dist/collapse'
import Modal from 'bootstrap/js/dist/modal'
import Dropdown from 'bootstrap/js/dist/dropdown'

import {doLast} from './module_last';
import { initFirebaseApp } from './module_firebase';
import './module_common_actions';

import { initNavbar } from './module_header';
import { manageLogin } from './module_auth_helper';

$(function () {
    initFirebaseApp()
    manageLogin()
    doLast()
    initNavbar()
});